import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';

import poolBackground from '../../assets/images/poolBackground.jpg';
import vegas from '../../assets/images/vegas.jpg';
import dragonBridge from '../../assets/images/dragonBridge.jpg';

const PhotoSlider = () => {
  const images = [poolBackground, vegas, dragonBridge ];

  // Custom Previous Arrow
  const PrevArrow = ({ onClick }) => (
    <IconButton
      onClick={onClick}
      sx={{
        position: 'absolute',
        top: '50%',
        left: '20px',
        transform: 'translateY(-50%)',
        zIndex: 2,
        color: 'white',
        backgroundColor: 'transparent',
        '&:hover': { color: '#ddd' },
      }}
    >
      <ArrowBackIos fontSize="large" />
    </IconButton>
  );

  // Custom Next Arrow
  const NextArrow = ({ onClick }) => (
    <IconButton
      onClick={onClick}
      sx={{
        position: 'absolute',
        top: '50%',
        right: '20px',
        transform: 'translateY(-50%)',
        zIndex: 2,
        color: 'white',
        backgroundColor: 'transparent',
        '&:hover': { color: '#ddd' },
      }}
    >
      <ArrowForwardIos fontSize="large" />
    </IconButton>
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    customPaging: (i) => (
      <div
        className="slick-dot"
        style={{
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          backgroundColor: 'white',
          border: '2px solid #ddd',
          margin: '0 5px',
          cursor: 'pointer',
          opacity: 0.8,
        }}
      />
    ),
    appendDots: (dots) => (
      <ul
        style={{
          size: '10px',
          bottom: '-25px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '30px',
        }}
      >
        {dots}
      </ul>
    ),
    // Add this event to change dot style based on active slide
    beforeChange: (current, next) => {
      const dots = document.querySelectorAll('.slick-dot');
      dots.forEach((dot, index) => {
        if (index === next) {
          dot.style.backgroundColor = '#444'; // Darker color for active dot
          dot.style.border = '2px solid #444';
          dot.style.opacity = 1;
        } else {
          dot.style.backgroundColor = 'white';
          dot.style.border = '2px solid #ddd';
          dot.style.opacity = 0.8;
        }
      });
    },
  };

  return (
    <Box
      sx={{
        //width: '99vw',
        height: '50vh',
        overflow: 'hidden',
        margin: 'auto',
        position: 'relative',
      }}
    >
      <Slider {...settings}>
        {images.map((image, index) => (
          <Box key={index} sx={{ position: 'relative' }}>
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              style={{
                width: '100%',
                height: '50vh',
                objectFit: 'cover',
              }}
            />
            {/* Overlay Text */}
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                zIndex: 1,
                color: 'white',
                textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 'bold',
                }}
              >
                Dreamer's Journey
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  mt: 1, // Margin top for spacing
                  fontWeight: '300',
                }}
              >
                Planning journey, creating memories
              </Typography>
            </Box>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default PhotoSlider;
